const object = value => value && typeof value === 'object' && !Array.isArray(value)
const integer = value => Number.isSafeInteger(value) && value >= 0
const identity = value => typeof value === 'string' && value.length > 0 && value.length <= 128 && value.trim() === value
const text = (value, limit) => typeof value === 'string' && value.length <= limit

export function controlGroupResult (response) {
  const data = response && response.data
  if (!object(data) || data.success === false || (data.status && data.status !== 200) || !object(data.result)) throw new Error('服务端返回格式异常，请刷新核对')
  return data.result
}

export function controlGroupRecord (value, expectedId) {
  if (!object(value) || !identity(value.id) || (expectedId && value.id !== expectedId) || !identity(value.productId) || !text(value.name, 128) || !value.name.trim() || !integer(value.revision) || !value.revision) throw new Error('群组信息无效，请刷新核对')
  if (value.description != null && !text(value.description, 512)) throw new Error('群组说明格式无效')
  return { id: value.id, name: value.name, description: value.description || '', productId: value.productId,
    productName: text(value.productName, 256) && value.productName ? value.productName : value.productId,
    revision: value.revision, createTime: value.createTime, modifyTime: value.modifyTime }
}

export function controlGroupPage (response, kind, productId) {
  const result = controlGroupResult(response)
  if (!integer(result.pageIndex) || !integer(result.pageSize) || !result.pageSize || result.pageSize > 100 || !integer(result.total) || !Array.isArray(result.data) || result.data.length > result.pageSize) throw new Error('分页信息无效，请重新加载')
  const offset = result.pageIndex * result.pageSize
  if (!Number.isSafeInteger(offset) || (result.total === 0 ? result.pageIndex !== 0 || result.data.length !== 0 : offset >= result.total || result.data.length !== Math.min(result.pageSize, result.total - offset))) throw new Error('分页范围与总数不一致，请重新加载')
  const seen = new Set()
  const data = result.data.map(row => {
    if (!object(row) || !identity(row.id) || seen.has(row.id)) throw new Error('列表数据无效，请重新加载')
    seen.add(row.id)
    if (kind === 'groups') return controlGroupRecord(row)
    if (!text(row.name, 256)) throw new Error('设备或产品名称无效')
    if (kind === 'products') return { id: row.id, name: row.name || row.id }
    if (!identity(row.productId) || row.productId !== productId || typeof row.joined !== 'boolean') throw new Error('设备产品或成员状态不一致，请重新加载')
    return { id: row.id, name: row.name || row.id, productId: row.productId, joined: row.joined, state: row.state }
  })
  return { pageIndex: result.pageIndex, pageSize: result.pageSize, total: result.total, data }
}

export function controlGroupMutation (response, previousRevision, selectedCount = 100) {
  const result = controlGroupResult(response)
  if (!integer(previousRevision) || !previousRevision || !integer(result.revision) || !integer(result.changed) || result.changed > Math.min(100, selectedCount) || result.revision !== previousRevision + 1) throw new Error('成员保存结果未确认，请刷新核对')
  return { revision: result.revision, changed: result.changed }
}

export function controlGroupDeleted (response, id, previousRevision) {
  const result = controlGroupResult(response)
  if (result.id !== id || result.deleted !== true || !integer(previousRevision) || !previousRevision || !integer(result.revision) || result.revision !== previousRevision + 1) throw new Error('删除结果未确认，请刷新核对')
  return true
}

export function controlGroupForm (form, creating) {
  const name = typeof form.name === 'string' ? form.name.trim() : ''
  const description = typeof form.description === 'string' ? form.description.trim() : ''
  const errors = { name: !name ? '请输入群组名称' : name.length > 128 ? '群组名称最多128个字符' : '',
    description: description.length > 512 ? '群组说明最多512个字符' : '', productId: creating && !identity(form.productId) ? '请选择所属产品' : '',
    revision: !creating && (!integer(form.revision) || !form.revision) ? '群组修订无效，请刷新后再编辑' : '' }
  return { errors, valid: !Object.values(errors).some(Boolean), data: { name, description, ...(creating ? { productId: form.productId } : { revision: form.revision }) } }
}

export function controlGroupDeviceIds (selected, rows, adding) {
  const ids = [...new Set(selected)]
  if (!ids.length || ids.length > 100 || ids.some(id => !identity(id) || !rows.some(row => row.id === id && (adding ? !row.joined : row.joined)))) throw new Error('请选择当前页可操作的设备，单次最多100台')
  return ids
}

export function controlGroupError (error) {
  const status = error && error.status
  if (status === 401) return '登录已失效，请重新登录'
  if (status === 403) return '群组或设备权限已变化，请刷新核对'
  if (status === 404) return '群组已删除或不可访问，请刷新列表'
  if (status === 409) return '群组已被其他操作修改，请刷新后重试'
  if (status === 429) return '请求过于频繁，请稍后重试'
  return error && error.message || '请求失败，请检查连接后重试'
}

export function controlGroupWriteBlocked (error) {
  return !error || !error.status || [401, 403, 404, 409].includes(error.status) || error.status >= 500
}

export function controlGroupDeviceState (state) {
  const value = object(state) ? state.value : state
  if (value === 'online') return '在线'
  if (value === 'offline') return '离线'
  if (value === 'notActive') return '未激活'
  return '未知'
}
